import { Component, Vue,  Prop } from "vue-property-decorator";
import dayjs from 'dayjs';

@Component({
})
export default class TimeAnalysisBarChart extends Vue {
  @Prop({ default: () => ([]) }) data: Array<any>
  @Prop({ default: () => ([]) }) readonly dataValue: any;
  @Prop({ default: '' }) readonly dataName: String;
  @Prop({ default: '' }) readonly unit: string;
  bizTypeList = [6,8,11]

  mounted() {
    this.init()
  }

  toolTipHtml(value){
    let html = ''
    this.dataValue.forEach(element => {
      if(dayjs(element.reportTime).format('mm:ss.SSS') === value[0].name){
        html = `${this.showName(element)} ${this.dataName}: ${this.addCompany(element.value)}<br />`
        html = html+`时间: ${dayjs(element.reportTime).format('mm:ss.SSS')}`
      }
    });
    return html
  }

  showName(element){
    let html = ''
    if(element.map){
      Object.keys(element.map).forEach((key) => {
        const unit = this.data.find(item => item.paramDesc === key).unit
        html = key + ': ' + element.map[key] + (unit ? unit : "") + '<br />'
      });
    }
    return html
  }

  addCompany(value){
    return value + (this.unit ? this.unit : "")
  }
  init() {
    const seriesData = []
    const legendData = []
    let seriesName = ''
    this.dataValue.forEach(res =>{
      legendData.push(dayjs(res.reportTime).format('mm:ss.SSS'))
      seriesData.push(res.value)
      seriesName = res.name
    })
    // 基于准备好的dom，初始化echarts实例
    var myChart = (this as any).$echarts.init(
      this.$refs.myChart as any
    );
    // 指定图表的配置项和数据
    var option = {
      title:{
        show:false
      },
      tooltip: {
        trigger: 'axis',
        formatter: (val) =>{
          return this.toolTipHtml(val)
        },
      },
      legend: {
        show: false
      },
      dataZoom: [
        {
            show: true,
            realtime: true,
            start: 0,
            end: 100,
            right: 80,
            left: 80
        }
      ],
      grid: {
        left: '30',
        right: '60',
        bottom: '60',
        top: '10',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLine: {onZero: true},
        data: legendData
      },
      color: ['#37A2DA','#32C5E9','#67E0E3','#9FE6B8','#FFDB5C','#ff9f7f','#fb7293','#E062AE','#E690D1','#e7bcf3','#9d96f5','#8378EA','#96BFFF'],
      yAxis: [
        {
          type: 'value',
          boundaryGap: true,
          axisLine: {
              show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel:{
            formatter: value =>{
              return this.addCompany(value)
            }
          }
        }
      ],
      series: [
        {
          name: seriesName,
          type: 'line',
          smooth: true,
          data: seriesData
        }
      ]
    };
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
  }
  
  render() {
    return (
      <div ref="myChart" style={{width: '100%', height: '325px'}}></div>
    )
  }
}